<template>
  <div
  class="MediaVideos">
    <NoFilesPage v-if="empty"/>
    <transition-group
    v-else
    tag="div"
    appear
    name="from-right-to-left"
    mode="out-in"
    class="MediaVideos__grid">
      <FileSquare
      v-for="file in videoFiles"
      :key="file.id"
      :file='file'/>
    </transition-group>
    <InViewportContainer
    v-if="hasNextToken('video')"
    container-id="MediaDashboardScrollable"
    :handler="loadMore"
    class="MediaDashboard__load-more">
      <i class="el-icon-loading MediaDashboard__load-icon"/>
    </InViewportContainer>
  </div>
</template>

<script>
import FileSquare from '@/components/file/square/FileSquare'

import MediaStateMixin from '@/components/mixins/MediaState.mixin'

export default {
  name: 'MediaVideos',

  components: {
    FileSquare
  },

  mixins: [
    MediaStateMixin
  ],

  computed: {
    videoFiles () {
      return this.files('video').slice(0).sort((f1, f2) => {
        return f1.updatedAtMillis < f2.updatedAtMillis ? 1 : -1
      })
    },
    empty () {
      return !this.videoFiles.length && !this.mediaBusy
    }
  },

  mounted () {
    this.getUpdates({ tab: 'video' })
  },

  methods: {
    loadMore () {
      this.getFiles({ tab: 'video' })
    }
  }
}
</script>

<style lang="scss">
@import 'MediaVideos';
</style>
